//moved hard coded dates  here for now
export const CUSTOM_DATE_FORMATS = {
  LongDateWithShortMonth: "DD-MMM-yyyy",
  ShortMonthShortYear:"MMM - YY",
  ShortMonthLongYear:"MMM yyyy",
  LongMonthLongYear:"MMMM, yyyy",
  MonthDayYear: "MM/DD/yyyy",
  YearMonthDay: "YYYYMMDD",
};
